<template>
    <v-container>
        <v-layout column>
            <v-flex>
                <p class="subheading mt-3 text-center">
                    För att läsa mer om hur statistiken är framtagen, klicka på "HUR JAG RÄKNAT"
                </p>
                <p class="subheading mt-3 text-center">
                    Radiokollen är oberoende och har inget samarbete med Sveriges Radio, Spotify, Bauer Media, Nordic Entertainment Group eller
                    andra svenska medieföretag.
                </p>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: "BottomIntroduction"
};
</script>